import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loginComponent from './login.component';

let loginModule = angular.module('login', [
  uiRouter
])

.component('login', loginComponent)

.config(($stateProvider) => {
  "ngInject";

  $stateProvider
    .state('auth.login', {
      name: 'auth.login',
      url: '/login',
      component: 'login'
    });
})

.name;

export default loginModule;



// WEBPACK FOOTER //
// ./client/app/components/login/login.js